import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BzgCheckboxComponent} from './checkbox/bzg-checkbox.component';
import {BzgLoaderComponent} from './loader/bzg-loader.component';

@NgModule({
  imports: [
    CommonModule
  ],
  exports: [
    BzgLoaderComponent
  ],
  declarations: [
    BzgLoaderComponent
  ]
})
export class BzgLoaderModule { }
